import type { RouteLocationRaw } from 'vue-router'

export const useIsExternalUrl = (
  to: string | RouteLocationRaw,
): boolean | null => {
  if (!to) return null

  // Get the URL
  const url = typeof to === 'string' ? to : (to as { path?: string }).path || ''

  // Check if the URL is external
  const regex = /^(https?:\/\/|www\.)/

  return regex.test(url)
}
